import type { HbmlElementNode } from "@holibob-packages/hbml";

export function HbmlRawTextNode({ content }: { content: HbmlElementNode }) {
    return <>{content.children[0].text}</>;
}
